const mapOptionalGoalCategoryIdToPrimaryGoalCategoryId = id => {
  switch (Number(id)) {
    case 31811:
      return 31803;
    case 31812:
      return 31804;
    case 31813:
      return 31805;
    case 31814:
      return 31806;
    case 31815:
      return 31807;
    case 31816:
      return 31808;
    case 31817:
      return 31809;
    case 31818:
      return 31810;
    case 667403:
      return 667339;
    case 667405:
      return 667401;
    case 657046:
      return 656447;
    case 670409:
      return 670401;
    case 670411:
      return 670403;
    case 670413:
      return 670405;
    case 670415:
      return 670407;
    case 747980:
      return 747968;
    case 747982:
      return 747970;
    case 747984:
      return 747972;
    case 747986:
      return 747974;
    case 747988:
      return 747976;
    case 747990:
        return 747978;
    default:
      return id;
  }
};

export default mapOptionalGoalCategoryIdToPrimaryGoalCategoryId;



// WEBPACK FOOTER //
// ./src/utils/mapOptionalGoalCategoryIdToPrimaryGoalCategoryId.js